<soft-page>
  <soft-page-header>
    <div class="flex items-center justify-start">
      <div class="flex flex-row items-center px-6 border-r min-w-[12rem]">
        <soft-icon name="fa-regular fa-calendar-lines fa-xl" class="mr-4"></soft-icon>
        <div class="flex flex-col items-start text-left">
          <div class="text-sm font-semibold">{{ 'Zeitraum' | translate }}</div>
          <div class="soft-link text-sm" (click)="editZeitraum()">{{ $safeNavigationMigration(query()?.vondatum) | format:'DATE.DEFAULT' }} - {{ $safeNavigationMigration(query()?.bisdatum) | format:'DATE.DEFAULT' }}</div>
        </div>
      </div>

      <soft-select-box title="Artikel" [value]="selectedArtikel()" (valueChange)="onArtikelChanged($event)" class="pl-6 min-w-[12rem]" icon="fa-regular fa-rectangle-barcode fa-xl">
        @for (artikel of artikel(); track artikel.id) {
          <soft-select-box-option [value]="artikel" [label]="artikel.artikelnummer + ' - ' + artikel.bezeichnung"></soft-select-box-option>
        }
      </soft-select-box>
    </div>
  </soft-page-header>

  <div class="flex flex-col md:flex-row gap-4 items-start mt-4">
    <div class="grid grid-cols-1 items-stretch justify-items-stretch justify-stretch lg:grid-cols-1 2xl:grid-cols-3 gap-4 w-full md:w-6/12 xl:w-7/12">
      @for (lagerliste of lagerlisten(); track lagerliste.artikel.id) {
        <soft-rohstoffbereitstellung-lager-card [lagerliste]="lagerliste"></soft-rohstoffbereitstellung-lager-card>
      }
    </div>
    <div class="flex flex-col soft-card !p-0 w-full md:w-6/12 xl:w-5/12 h-auto">
     <div class="flex items-center justify-between px-4 pb-3 pt-3 w-full border-b">
        <h6 class="text-base soft-overline !mb-0 pb-0">Kalkulator</h6>
     </div>

      <div class="flex flex-col mt-1 px-4 pt-1 pb-3">
        <soft-fetteinheiten-kalkulator [zeilen]="kalkulatorZeilen()"></soft-fetteinheiten-kalkulator>
      </div>
    </div>
  </div>

  <div class="flex flex-col mb-3 mt-4 overflow-x-auto">
    <table class="soft-table-2 mb-3">
      <thead>
      <tr>
        <th class="!text-left w-6/12">Datum</th>
        <th class="!text-right w-1/12 min-w-[8rem]" softSortHeader="menge" [sort]="sort()" (sortChange)="sortChanged($event)">KG</th>
        <th class="!text-right w-1/12 min-w-[8rem]" softSortHeader="gewicht" [sort]="sort()" (sortChange)="sortChanged($event)">Liter</th>
        <th class="!text-right w-1/12 min-w-[8rem]" softSortHeader="fetteinheiten" [sort]="sort()" (sortChange)="sortChanged($event)">FE</th>
        <th class="!text-right w-1/12 min-w-[8rem]" softSortHeader="fetteinheitenProz" [sort]="sort()" (sortChange)="sortChanged($event)">FE %</th>
        <th class="!text-right w-1/12 min-w-[8rem]" softSortHeader="eiweisseinheiten" [sort]="sort()" (sortChange)="sortChanged($event)">EE</th>
        <th class="!text-right w-1/12 min-w-[8rem]" softSortHeader="eiweisseinheitenProz" [sort]="sort()" (sortChange)="sortChanged($event)">EE %</th>
      </tr>
      </thead>
      <tbody>
      @for (row of verbraeuche(); track row.datum) {
      <tr (click)="selectRow(row)">
        <td
          [attr.data-label]="'Datum'"
          class="!text-left cursor-pointer w-6/12"
          [ngClass]="selectedRow()?.datum === row.datum ? '!bg-selected' : ''">{{ row.datum | format:'DATE.DEFAULT' }}</td>
        <td
          [attr.data-label]="'KG'"
          class="!text-right cursor-pointer w-1/12 min-w-[8rem]"
          [ngClass]="selectedRow()?.datum === row.datum ? '!bg-selected' : ''">{{ row.werte.gewicht | number:'1.2-2' }}</td>
        <td
          [attr.data-label]="'Liter'"
          class="!text-right cursor-pointer w-1/12 min-w-[8rem]"
          [ngClass]="selectedRow()?.datum === row.datum ? '!bg-selected' : ''">{{ row.werte.menge | number:'1.2-2' }}</td>
        <td
          [attr.data-label]="'FE'"
          class="!text-right cursor-pointer w-1/12 min-w-[8rem]"
          [ngClass]="selectedRow()?.datum === row.datum ? '!bg-selected' : ''">{{ row.werte.fetteinheiten | number:'1.2-2' }}</td>
        <td
          [attr.data-label]="'FE %'"
          class="!text-right cursor-pointer w-1/12 min-w-[8rem]"
          [ngClass]="selectedRow()?.datum === row.datum ? '!bg-selected' : ''">{{ ((row.werte.fetteinheitenProz || 0) / 100) | percent:'1.2-2' }}</td>
        <td
          [attr.data-label]="'EE'"
          class="!text-right cursor-pointer w-1/12 min-w-[8rem]"
          [ngClass]="selectedRow()?.datum === row.datum ? '!bg-selected' : ''">{{ row.werte.eiweisseinheiten | number:'1.2-2' }}</td>
        <td
          [attr.data-label]="'EE %'"
          class="!text-right cursor-pointer w-1/12 min-w-[8rem]"
          [ngClass]="selectedRow()?.datum === row.datum ? '!bg-selected' : ''">{{ ((row.werte.eiweisseinheitenProz) / 100) | percent:'1.2-2' }}</td>
      </tr>
      }
      </tbody>
    </table>
  </div>

  @if ((sortedDetails()?.length ?? 0) > 0) {
    <div class="flex flex-col mb-3 mt-4 overflow-x-auto">
      <table class="soft-table-2 mb-3">
        <thead>
        <tr>
          <th class="!text-left w-6/12" softSortHeader="bezeichnung" [sort]="sortDetail()" (sortChange)="sortDetailChanged($event)">Prod-Artikel</th>
          <th class="!text-right w-1/12 min-w-[8rem]" softSortHeader="menge" [sort]="sortDetail()" (sortChange)="sortDetailChanged($event)">KG</th>
          <th class="!text-right w-1/12 min-w-[8rem]" softSortHeader="gewicht" [sort]="sortDetail()" (sortChange)="sortDetailChanged($event)">Liter</th>
          <th class="!text-right w-1/12 min-w-[8rem]" softSortHeader="fetteinheiten" [sort]="sortDetail()" (sortChange)="sortDetailChanged($event)">FE</th>
          <th class="!text-right w-1/12 min-w-[8rem]" softSortHeader="fetteinheitenProz" [sort]="sortDetail()" (sortChange)="sortDetailChanged($event)">FE %</th>
          <th class="!text-right w-1/12 min-w-[8rem]" softSortHeader="eiweisseinheiten" [sort]="sortDetail()" (sortChange)="sortDetailChanged($event)">EE</th>
          <th class="!text-right w-1/12 min-w-[8rem]" softSortHeader="eiweisseinheitenProz" [sort]="sortDetail()" (sortChange)="sortDetailChanged($event)">EE %</th>
        </tr>
        </thead>
        <tbody>
        @for (row of sortedDetails(); track $index) {
          <tr>
            <td [attr.data-label]="'Datum'" class="!text-left w-6/12">{{ row.artikel.bezeichnung }}</td>
            <td [attr.data-label]="'KG'" class="!text-right w-1/12 min-w-[8rem]">{{ row.werte.gewicht | number:'1.2-2' }}</td>
            <td [attr.data-label]="'Liter'" class="!text-right w-1/12 min-w-[8rem]">{{ row.werte.menge | number:'1.2-2' }}</td>
            <td [attr.data-label]="'FE'" class="!text-right w-1/12 min-w-[8rem]">{{ row.werte.fetteinheiten | number:'1.2-2' }}</td>
            <td [attr.data-label]="'FE %'" class="!text-right w-1/12 min-w-[8rem]">{{ ((row.werte.fetteinheitenProz ||0) / 100) | percent:'1.2-2' }}</td>
            <td [attr.data-label]="'EE'" class="!text-right w-1/12 min-w-[8rem]">{{ row.werte.eiweisseinheiten | number:'1.2-2' }}</td>
            <td [attr.data-label]="'EE %'" class="!text-right w-1/12 min-w-[8rem]">{{ ((row.werte.eiweisseinheitenProz) / 100) | percent:'1.2-2' }}</td>
          </tr>
        }
        </tbody>
      </table>
    </div>
  }
</soft-page>
